import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const PlaceLeftIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 19.3604H10.6406C7.32706 19.3604 4.64086 16.6739 4.64062 13.3604V10.6396C4.64077 7.32607 7.32701 4.63965 10.6406 4.63965H12V19.3604Z" fill="currentColor" />;
    t1 = <path d="M15 4C17.7614 4 20 6.23858 20 9V15C20 17.7614 17.7614 20 15 20H9C6.23858 20 4 17.7614 4 15V9C4 6.23858 6.23858 4 9 4H15ZM9 5.5C7.067 5.5 5.5 7.067 5.5 9V15C5.5 16.933 7.067 18.5 9 18.5H15C16.933 18.5 18.5 16.933 18.5 15V9C18.5 7.067 16.933 5.5 15 5.5H9Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default PlaceLeftIcon;